export const pricingTiers = [
  {
    key: "starter",
    title: "Starter",
    price: "$99/mo",
    meter: "+ $0.20/delivery",
    branding: "TrackLastMile branding",
    limit: "Up to 25 stores",
    support: "Email support",
    ctaLabel: "Start Free Trial",
    ctaLink: "/start-free-trial",
    featured: false,
  },
  {
    key: "growth",
    title: "Growth",
    badge: "Most Popular",
    price: "$299/mo",
    meter: "+ $0.05/delivery",
    branding: "Your logo and colors",
    limit: "Up to 100 stores",
    support: "Priority support",
    ctaLabel: "Start Free Trial",
    ctaLink: "/start-free-trial",
    featured: true,
  },
  {
    key: "pro",
    title: "Pro White-Label",
    price: "$4,999 setup + $499/mo",
    meter: "Unlimited deliveries",
    branding: "Your branded apps in App Store + Play Store",
    limit: "Unlimited stores",
    support: "Dedicated onboarding",
    ctaLabel: "Book Demo",
    ctaLink: "/trial-register",
    featured: false,
  },
  {
    key: "enterprise",
    title: "Enterprise",
    price: "Starts at $14,999",
    meter: "One-time license",
    branding: "Source code + self-host",
    limit: "Unlimited everything",
    support: "Custom + SLA",
    ctaLabel: "Contact Sales",
    ctaLink: "/trial-register",
    featured: false,
  },
];

export const planIncludes =
  "All plans include the customer app, store portal, driver app, admin dashboard, live GPS tracking, Stripe payments, Twilio SMS, and proof of delivery.";

export const faqItems = [
  {
    question: "How fast can I launch?",
    answer:
      "Starter and Growth plans: same day. Pro White-Label (your own branded apps in the App Store and Play Store): 2 to 4 weeks for app submission and approval.",
  },
  {
    question: "Can I use this outside North America?",
    answer:
      "Yes. The platform supports Stripe-eligible countries for payments, and SMS/maps work globally.",
  },
  {
    question: "Do you take a cut of my orders?",
    answer:
      "No. You keep 100% of order revenue. We charge a flat monthly fee plus a small per-delivery cost on metered plans.",
  },
  {
    question: "What if I have my own developers?",
    answer:
      "Enterprise gives you the source code and self-hosting rights. Build on top of it however you want.",
  },
  {
    question: "Do you offer a free trial?",
    answer:
      "Yes. 14 days, no credit card required for Starter and Growth.",
  },
];
